// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".figure[data-v-e742f5d8]{background-color:#f0f1f6;border-radius:9999px;display:flex;align-items:center;justify-content:center;height:5rem;overflow:hidden}.figure[data-v-e742f5d8]:hover{--tw-shadow:0 25px 50px -12px rgba(0,0,0,0.25);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.figure[data-v-e742f5d8]{width:5rem}", ""]);
// Exports
module.exports = exports;
